import { useTranslation } from "react-i18next";
import { useUser } from "../context/UserContext";

/**
 * Full-screen blocking overlay shown while the user's data clear is fan-out
 * in progress on the backend. Reads `userProfile.dataClearing` so it appears
 * in every tab the user has open — protects against the case where the user
 * tries to create new data in another tab while the clear is mid-flight.
 *
 * Cleared by the backend setting `dataClearing: false` once fan-out finishes,
 * which propagates here via React Query's window-focus refetch.
 */
export default function DataClearOverlay() {
  const { t } = useTranslation("common");
  const { userProfile } = useUser();
  if (!userProfile?.dataClearing) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        backgroundColor: "rgba(15, 23, 42, 0.75)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
      }}
      role="dialog"
      aria-modal="true"
      aria-label={t("dataClearOverlay.ariaLabel")}
    >
      <div
        style={{
          background: "#ffffff",
          borderRadius: 12,
          padding: "32px 28px",
          maxWidth: 420,
          width: "100%",
          textAlign: "center",
          boxShadow: "0 24px 48px rgba(0, 0, 0, 0.25)",
        }}
      >
        <div
          className="spinner-small"
          style={{ margin: "0 auto 16px", width: 32, height: 32 }}
        />
        <h2 style={{ margin: 0, color: "#1a4d3e", fontSize: 20 }}>
          {t("dataClearOverlay.title")}
        </h2>
        <p style={{ marginTop: 12, color: "#475569", fontSize: 14, lineHeight: 1.5 }}>
          {t("dataClearOverlay.message")}
        </p>
      </div>
    </div>
  );
}
